export enum ModalDismissType {
  cross,
  cancel
}
